import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";

// Types
import { User } from "../../../../types";

// Components
import PersonalInfoRow from "../../components/PersonalInfoRow";

// Styles
import styles from './style.module.scss';

interface PersonalInfoProps {
  user: User | null;
}

const PersonalInfo: React.FC<PersonalInfoProps> = ({ user }) => {
  // Translations
  const { t } = useTranslation();

  // Memoized functions
  const renderRows = useCallback(() => {
    const rows = [
      {
        id: 'learning_preferences',
        icon: <span className="text-2xl">❤️</span>,
        title: t('profile.personal_infos.learning_preferences.title'),
        description: t('profile.personal_infos.learning_preferences.description'),
        onChange: () => { }
      },
      {
        id: 'study_style',
        icon: <span className="text-2xl">📚</span>,
        title: t('profile.personal_infos.study_style.title'),
        description: t('profile.personal_infos.study_style.description'),
        onChange: () => { }
      },
      {
        id: 'goals_motivation',
        icon: <span className="text-2xl">🏆</span>,
        title: t('profile.personal_infos.goals_motivation.title'),
        description: t('profile.personal_infos.goals_motivation.description'),
        onChange: () => { }
      },
      {
        id: 'learning_challenges',
        icon: <span className="text-2xl">🎓</span>,
        title: t('profile.personal_infos.learning_challenges.title'),
        description: t('profile.personal_infos.learning_challenges.description'),
        onChange: () => { }
      },
      {
        id: 'device_accessibility',
        icon: <span className="text-2xl">💻</span>,
        title: t('profile.personal_infos.device_accessibility.title'),
        description: t('profile.personal_infos.device_accessibility.description'),
        onChange: () => { }
      },
      {
        id: 'feedback_style',
        icon: <span className="text-2xl">🚀</span>,
        title: t('profile.personal_infos.feedback_style.title'),
        description: t('profile.personal_infos.feedback_style.description'),
        onChange: () => { }
      },
      {
        id: 'emotional_state',
        icon: <span className="text-2xl">🧘</span>,
        title: t('profile.personal_infos.emotional_state.title'),
        description: t('profile.personal_infos.emotional_state.description'),
        onChange: () => { }
      }
    ]

    return (
      <div className={styles.rows}>
        {rows.map((row) => (
          <PersonalInfoRow
            key={row.id}
            icon={row.icon}
            title={row.title}
            description={row.description}
            onChange={row.onChange}
          />
        ))}
      </div>
    )
  }, [t]);

  // Styles
  const rootClasses = "flex flex-col gap-2";
  return (
    <div className={rootClasses}>
      {renderRows()}
    </div>
  );
};

export default PersonalInfo;
